define('AwaLabs.WineRingRec', [
    'WineRingRec.Reccomendations.PDPButton.View',
    'underscore',
    'jQuery',
    'SC.Configuration',
    'Profile.Model',
    'WineRingRec.Recommendations.View',
    'Backbone'
], function WineRingRec(
    WineRingRecReccomendationsPDPButtonView,
    _,
    jQuery,
    Configuration,
    ProfileModel,
    WineRingRecRecommendationsView,
    Backbone
) {
    'use strict';

    return {
        getConfigPerStore: function getConfigPerStore() {
            var store = ProfileModel.getInstance().get('store');
            if (store) {
                return _.findWhere(Configuration.get('WineRingRec.configPerStore', []), { store: store.get('internalid').toString() });
            }
            return null;
        },
        loadScript: function loadScript() {
            var originalDefine = define;
            // eslint-disable-next-line no-global-assign
            define = null;
            return jQuery.getScript(Configuration.get('WineRingRec.script',
                'https://instantrec.winering.com/instantrec-js.js'), function getScriptFn() {
                // eslint-disable-next-line no-global-assign
                define = originalDefine;
                Backbone.Events.trigger('WineRingRec:Script.Loaded');
                window.instantrecLoaded = true;
            });
        },
        loadCss: function loadCss() {
            jQuery('head').append(jQuery('<link rel="stylesheet" type="text/css" />').attr('href',
                Configuration.get('WineRingRec.css', 'https://instantrec.winering.com/instantrec-style.css')));
        },
        appendDivWrapper: function appendDivWrapper() {
            var dateTime = new Date().getTime();
            jQuery('body')
                .remove('.instantrec')
                .append(jQuery('<div>')
                    .attr('id', 'instantrec-' + dateTime)
                    .attr('class', 'instantrec')
                );
            return dateTime;
        },

        addEventsOnViews: function addEventsOnViews(application) {
            var self = this;
            var layout = application.getComponent('Layout');
            layout.addToViewEventsDefinition('Footer.View', 'click [data-action="show-winering-footer"]', function showModal() {
                self.showModalWineRing(application);
            });
            layout.addToViewEventsDefinition('Header.Menu.View', 'click [data-action="show-winering-header"]', function showModal() {
                self.showModalWineRing(application);
            });

            layout.addToViewEventsDefinition('WineRingRec.Reccomendations.PDPButton.View', 'click [data-action="show-winering-header"]', function showModal() {
                self.showModalWineRing(application);
            });
        },

        showModalWineRing: function showModalWineRing() {
            var config = this.getConfigPerStore() || {};
            var datetime = this.appendDivWrapper();
            var instarec;
            this.removeSessionData();
            instarec = jQuery('body').wrInstantRec({
                integration_id: config.integrationId || '8299',
                questionnaire_id: config.questionnaireId || '17',
                resultsRedirect: config.resultsRedirect || 'recommendations',
                customStyling: {
                    basicButton: 'red',
                    questionnaire: {
                        selector: 'selector-container',
                        rangeTrackActive: 'range-line',
                        rangeDrag: 'drag-selector'
                    }
                }
            });

            // aca aparece el custionario
            instarec.wrInstantRec('show', {
                type: 'questionnaire',
                element: jQuery('#instantrec' + datetime)
            });
        },

        initPlugin: function initPlugin() {
            var self = this;
            var config = self.getConfigPerStore() || {};
            if (config) {
                self.loadCss();
                return self.loadScript();
            }
            return jQuery.Deferred();
        },

        removeSessionData: function removeSessionData() {
            sessionStorage.removeItem('wrirjs_questionnaire_17_post');
            sessionStorage.removeItem('wrirjs_questionnaire_17_selections');
            sessionStorage.removeItem('wrirjs_questionnaire_17_questionnaire');
            sessionStorage.removeItem('wrirjs_questionnaire_17_postedquery');
        },

        mountToApp: function mountToApp(container) {
            var self = this;
            var layout = container.getComponent('Layout');
            var pageType = container.getComponent('PageType');

            if (SC.ENVIRONMENT.jsEnvironment === 'browser' && pageType) {
                self.addEventsOnViews(container);
                container.getLayout().on('afterAppendView', function afterAppendViewFn() {
                    if (!window.instantrecLoaded) {
                        self.initPlugin();
                    }
                });
                pageType.registerPageType({
                    name: 'recommendations',
                    routes: ['recommendations'],
                    view: WineRingRecRecommendationsView
                });
            }

            layout.addToViewContextDefinition('ProductDetails.Full.View', 'isWine', 'boolean', function addIsWineAttr(context) {
                var wineringClasses = Configuration.get('wineRing.classes') || '';
                var classesSeparated;
                var isWineringClass;
                if (wineringClasses) {
                    classesSeparated = wineringClasses.split(',');
                    isWineringClass = classesSeparated && classesSeparated.indexOf(context.model.item.class) >= 0;
                }
                return isWineringClass;
            });

            layout.addChildView('InstantRecommendation.Button', function addInstantRecommendationButton() {
                return new WineRingRecReccomendationsPDPButtonView();
            });
        }
    };
});
